module.exports = __webpack_public_path__ + "static/media/5577881.500b9e4e.jpg";